module.exports = __webpack_public_path__ + "img/introduction.bc2b8c29.svg";